import { render, staticRenderFns } from "./FTViewBizInfo.vue?vue&type=template&id=3ab6bdaf&"
import script from "./FTViewBizInfo.vue?vue&type=script&lang=js&"
export * from "./FTViewBizInfo.vue?vue&type=script&lang=js&"
import style0 from "./FTViewBizInfo.vue?vue&type=style&index=0&id=3ab6bdaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports